import React from "react";
import styles from "../styles/promise.module.css";

function Promise(props) {
  const section = props.section;
  if (section === "squirrels") {
    return (
      <section className={styles.promise}>
        <h2>Our Promise</h2>
        <p>I promise to do my best to be kind and helpful and to love God.</p>
      </section>
    );
  } else if (section === "beavers") {
    return (
      <section className={styles.promise}>
        <h2>Our Promise</h2>
        <p>I promise to do my best to be kind and helpful and to love God.</p>
      </section>
    );
  } else if (section === "cubs") {
    return (
      <section className={styles.promise}>
        <h2>Our Promise</h2>
        <p>I promise that I will do my best <br /> to do my duty to God and to The King, <br /> to help other people <br /> and to keep the Cub Scout Law.</p>
      </section>
    );
  } else if (section === "scouts") {
    return (
      <section className={styles.promise}>
        <h2>Our Promise</h2>
        <p>On my honour, <br /> I promise that I will do my best <br /> to do my duty to God and to The King, <br /> to help other people <br /> and to keep the Scout Law.</p>
      </section>
    );
  } else {
    return (
        <h1>You should not be seeing this!</h1>
    );
  }
}

export default Promise;
